export default __webpack_public_path__ + "52e6dccff7c605f562dde0d60cb5faa7.svg";